var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import sizes from "./sizes";
/**
 * A download icon.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function InfoIcon(_a) {
    var { className, size = "xsmall" } = _a, rest = __rest(_a, ["className", "size"]);
    return (_jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", 
        // @ts-ignore
        sx: {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: "middle",
        }, className: className, viewBox: "0 0 20 20" }, rest, { children: _jsxs("g", { fill: "none", fillRule: "evenodd", stroke: "none", strokeWidth: "1", children: [_jsx("circle", { cx: "10", cy: "10", r: "10", fill: "currentColor" }), _jsx("text", { fill: "#FFF", fontFamily: "SourceSansPro-Bold, Source Sans Pro", fontSize: "12", fontWeight: "bold", children: _jsx("tspan", { x: "8.344", y: "14", children: "i" }) })] }) })));
}
//# sourceMappingURL=InfoIcon.js.map